<template>
    <div>
        党史资料
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="sass" scoped>

</style>